module.exports = __webpack_public_path__ + "img/020029.dbea5024.png";